import { GerantContainer } from '../components/GerantContainer';

export const GerantAccount = () => {
  return (
    <GerantContainer clicked='account'>
      <div>
        <h2>Gerant compte</h2>
      </div>
    </GerantContainer>
  );
};
